/** @format */

import { ModuleWithProviders, NgModule } from "@angular/core";
import { HomeComponent } from "./components/home/home.component";
import { HistoryComponent } from "./components/history/history.component";
import { HeaderComponent } from "./components/header/header.component";
import { LoaderModule } from "mis-design-system/loader";
import { ButtonModule } from "mis-design-system/button";
import { CommonModule } from "@angular/common";
import { ApiService } from "./services/api.service";
import { BookingDataService } from "./services/booking-data.service";
import { WidgetCardComponent } from "./components/cards/widget-card/widget-card.component";
import { BookingCardComponent } from "./components/cards/booking-card/booking-card.component";
import { ListCardComponent } from "./components/cards/list-card/list-card.component";
import { ListCardRowComponent } from "./components/cards/list-card/list-card-row/list-card-row.component";
import { CustomDatePipe } from "./pipes/custom-date.pipe";
import { CustomTimePipe } from "./pipes/custom-time.pipe";
import { OfficeNamePipe } from "./pipes/office-name.pipe";
import { DrawerModule } from "mis-design-system/drawer";
import { DrawerModule as DrawerMod } from "mis-design-system/drawer";
import { MisMealModule } from "@mis-wis/meal";
import { BookingFormComponent } from "./components/forms/booking-form/booking-form.component";
import { DropdownModule } from "mis-crystal-design-system/dropdown";
import { ReactiveFormsModule } from "@angular/forms";
import { ModalModule } from "mis-design-system/modal";
import { MisInputModule } from "mis-crystal-design-system/input";
import { FilterShiftsBeforePipe } from "./pipes/filter-shifts-before.pipe";
import { CommuteService } from "./services/commute.service";
import { CommuteComponent } from "./components/forms/commute/commute.component";
import { TransportTextPipe } from "./pipes/transport-text.pipe";
import { DeleteConfirmationComponent } from "./components/forms/delete-confirmation/delete-confirmation.component";
import { ValidateCutoffPipe } from "./pipes/validate-cutoff.pipe";
import { EmpUserService } from "./services/emp-user.service";
import { UpcomingBookingsComponent } from "./components/modals/upcoming-bookings/upcoming-bookings.component";
import { BookingConfirmationComponent } from "./components/forms/booking-confirmation/booking-confirmation.component";
import { CheckinConfirmComponent } from "./components/modals/checkin-confirm/checkin-confirm.component";
import { SafePipe } from "./pipes/safe.pipe";
import { HomeDataService } from "./services/home-data.service";
import { SeatService } from "./services/seat.service";
import { SeatComponent } from "./components/forms/seat/seat.component";
import { SeatTextPipe } from "./pipes/seat-text.pipe";
import { MisMenuModule } from "./modules/menu/menu.module";
import { QuickActionsComponent } from "./components/modals/quick-actions/quick-actions.component";
import { PreferenceDataService } from "./services/preference-data.service";
import { MeetingCardComponent } from "./components/cards/meeting-card/meeting-card.component";
import { CalenderCardComponent } from "./components/cards/calender-card/calender-card.component";
import { ConfigurationService } from "./services/configuration.service";
import { LoaderService } from "./services/loader.service";
import { OverlayModule } from "@angular/cdk/overlay";
import { LoaderComponent } from "./components/modals/loader/loader.component";
import { FabModule } from "mis-design-system/fab";
import { TooltipModule } from "mis-design-system/tooltip";
import { ToolTipModule } from "mis-crystal-design-system/tooltip";
import { MisDateRangePickerConfig, MisDatePickerModule } from "mis-design-system/datepicker";
import { TeamCalendarService } from "./services/team-calendar.service";
import { ParkingComponent } from "./components/forms/parking/parking.component";
import { MealService } from "@mis-wis/meal";
import { AdditionalTypePipe } from "./pipes/additional-type.pipe";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { BookingComponent } from "./components/modals/booking/booking.component";
import { BodyComponent } from "./components/routings/body/body.component";
import { CalendarComponent } from "./components/routings/calendar/calendar.component";
import { AddonWrapperComponent } from "./components/modals/addon-wrapper/addon-wrapper.component";
import { CreateBookingComponent } from "./components/modals/create-booking/create-booking.component";
import { WidgetService } from "./services/widget.service";
import { FilterOutBookingPipe } from "./pipes/filter-out-booking.pipe";
import { AdhocShiftsComponent } from "./components/modals/adhoc-shifts/adhoc-shifts.component";
import { ShiftStylePipe } from "./components/modals/adhoc-shifts/shift-style.pipe";
import { ModalModule as MisModalModule } from "mis-design-system/mis-modal";
import { IpConsentComponent } from "./components/modals/ip-consent/ip-consent.component";
import { CookieService } from "./services/cookie.service";
import { LayoutModule } from "@angular/cdk/layout";
import { IconOverFlowPipe } from "./components/cards/list-card/icon-check.pipe";
import { VaccinationEligibilityComponent } from "./components/modals/vaccination-eligibility/vaccination-eligibility.component";
import { DatepickerModuleV2 } from "mis-crystal-design-system/datepicker_v2";
import { RecurrenceBookingFormComponent } from "./components/forms/recurrence-booking-form/recurrence-booking-form.component";
import { CheckboxModule } from "mis-design-system/checkbox";
import { RadioButtonModule } from "mis-crystal-design-system/radio-button";
import { RecurrenceBookingSuccessComponent } from "./components/modals/recurrence-booking-success/recurrence-booking-success.component";
import { UserRequestDTOSPipe } from "./pipes/user-request-dtos.pipe";
import { RecurrenceConfirmationComponent } from "./components/modals/recurrence-confirmation/recurrence-confirmation.component";
import { LoaderWithMessageComponent } from "./components/modals/loader-with-message/loader-with-message.component";
import { ParkingGridFloorPlanComponent } from "./components/forms/parking-grid-floor-plan/parking-grid-floor-plan.component";
import { HttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateModule, TranslateLoader, TranslateService } from "@ngx-translate/core";
import { ToastService } from "mis-crystal-design-system/toast";
import { TranslateToastService } from "./services/translatetoast.service";
import { CheckLanguagePipe } from "./pipes/check-language.pipe";
import { WisConfigService } from "./services/wis-config.service";
import { MisEmployeeWebExpRoutingModule } from "./mis-employee-web-exp-routing.module";
import { A11yModule } from "@angular/cdk/a11y";
import { FormsService } from "./services/forms.service";
import { ShuttlePipe } from "./pipes/shuttle.pipe";
import { SwitchModule } from "mis-crystal-design-system/switch";
import { VirtualScrollModule } from "mis-crystal-design-system/virtual-scroll";
import { CheckoutConfirmComponent } from "./components/modals/checkout-confirm/checkout-confirm.component";
import { DynamicFormModule } from "mis-crystal-design-system/dynamic-form";
import { ParkingDisclaimerComponent } from "./components/modals/parking-disclaimer/parking-disclaimer.component";
import { VehicleCreateFormComponent } from "./components/forms/vehicle-create-form/vehicle-create-form.component";
import { TextModifierPipe } from "./pipes/text-modifier.pipe";
import { MealFeedbackCardComponent } from './components/cards/meal-feedback-card/meal-feedback-card.component';
import { MealListCardComponent } from './components/cards/meal-feedback-card/meal-list-card/meal-list-card.component';
import { StarRatingModule } from "mis-crystal-design-system/star-rating";
import { MealFeedbackModalComponent } from './components/modals/meal-feedback-modal/meal-feedback-modal.component';
import { AsyncDropdownModule } from "mis-crystal-design-system/async-search-dropdown";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "i18n/", ".json");
}
@NgModule({
  declarations: [
    HomeComponent,
    HistoryComponent,
    HeaderComponent,
    WidgetCardComponent,
    BookingCardComponent,
    ListCardComponent,
    ListCardRowComponent,
    CustomDatePipe,
    CustomTimePipe,
    OfficeNamePipe,
    BookingFormComponent,
    FilterShiftsBeforePipe,
    CommuteComponent,
    TransportTextPipe,
    DeleteConfirmationComponent,
    ValidateCutoffPipe,
    UpcomingBookingsComponent,
    BookingConfirmationComponent,
    CheckinConfirmComponent,
    SafePipe,
    SeatComponent,
    SeatTextPipe,
    QuickActionsComponent,
    MeetingCardComponent,
    CalenderCardComponent,
    LoaderComponent,
    ParkingComponent,
    AdditionalTypePipe,
    BookingComponent,
    BodyComponent,
    CalendarComponent,
    AddonWrapperComponent,
    CreateBookingComponent,
    FilterOutBookingPipe,
    AdhocShiftsComponent,
    ShiftStylePipe,
    IpConsentComponent,
    IconOverFlowPipe,
    VaccinationEligibilityComponent,
    RecurrenceBookingFormComponent,
    RecurrenceBookingSuccessComponent,
    UserRequestDTOSPipe,
    RecurrenceConfirmationComponent,
    LoaderWithMessageComponent,
    ParkingGridFloorPlanComponent,
    CheckLanguagePipe,
    ShuttlePipe,
    CheckoutConfirmComponent,
    ParkingDisclaimerComponent,
    VehicleCreateFormComponent,
    TextModifierPipe,
    MealFeedbackCardComponent,
    MealListCardComponent,
    MealFeedbackModalComponent
  ],
  imports: [
    CommonModule,
    LoaderModule,
    MisEmployeeWebExpRoutingModule,
    A11yModule,
    ButtonModule,
    StarRatingModule,
    AsyncDropdownModule,
    MisMealModule.forRoot(),
    MisDatePickerModule.forRoot(),
    DrawerModule.forChild(),
    DrawerMod.forChild(),
    DropdownModule.forRoot(),
    ReactiveFormsModule,
    ModalModule.forChild(),
    TooltipModule.forRoot(),
    ToolTipModule,
    MisMenuModule,
    OverlayModule,
    FabModule.forRoot(),
    ScrollingModule,
    MisInputModule,
    MisModalModule.forChild(),
    LayoutModule,
    DatepickerModuleV2,
    CheckboxModule,
    SwitchModule,
    RadioButtonModule.forRoot(),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    VirtualScrollModule,
    DynamicFormModule
  ],
  exports: [HomeComponent, HistoryComponent, BookingComponent, VehicleCreateFormComponent],
  entryComponents: [
    DeleteConfirmationComponent,
    CheckinConfirmComponent,
    CheckoutConfirmComponent,
    UpcomingBookingsComponent,
    BookingConfirmationComponent,
    LoaderComponent,
    BookingComponent,
    AddonWrapperComponent,
    CreateBookingComponent,
    IpConsentComponent,
    AdhocShiftsComponent,
    VaccinationEligibilityComponent,
    RecurrenceBookingSuccessComponent,
    RecurrenceConfirmationComponent,
    LoaderWithMessageComponent,
    ParkingDisclaimerComponent,
    VehicleCreateFormComponent
  ],
  providers: [MisDateRangePickerConfig]
})
export class MisEmployeeWebExpModule {
  static forRoot(): ModuleWithProviders<MisEmployeeWebExpModule> {
    return {
      ngModule: MisEmployeeWebExpModule,
      providers: [
        EmpUserService,
        ApiService,
        MealService,
        BookingDataService,
        CommuteService,
        HomeDataService,
        SeatService,
        PreferenceDataService,
        ConfigurationService,
        LoaderService,
        TeamCalendarService,
        WidgetService,
        CookieService,
        FormsService,
        {
          provide: ToastService,
          useClass: TranslateToastService
        },
        {
          provide: TranslateService,
          useClass: TranslateService
        },
        WisConfigService
      ]
    };
  }
}
